module.exports = __webpack_public_path__ + "media/images/registration-bg-bb4c304eb6147a1524d3dfb744b0ab19.png";